import { z } from "zod";

export const maskSearchFragment = {
  action: z.string().optional(),
  prefill: z.record(z.string(), z.unknown()).optional(),
};
